import Client from '@/clients/apiClient';
import humps from 'humps';
import { stringify } from 'query-string';

const resource = 'reports';

export default {
  getOverdueLoans(payload) {
    return Client.get(
      `/${resource}/loan?page=${payload.page}&limit=${payload.perPage}&${stringify(
        humps.decamelizeKeys(payload.filters)
      )}`
    );
  },
  export(payload) {
    return Client.get(
      `/${resource}/loan/export?${stringify(humps.decamelizeKeys(payload.filters))}`
    );
  },
  getEndDay(payload) {
    return Client.get(
      `/${resource}/end-day?page=${payload.page}&limit=${payload.perPage}&${stringify(
        humps.decamelizeKeys(payload.filters)
      )}`
    );
  },
  exportEndDay(payload) {
    return Client.get(
      `/${resource}/end-day/export?${stringify(humps.decamelizeKeys(payload.filters))}`
    );
  },
  dashboard() {
    return Client.get(`/${resource}/dashboard`);
  },
  endDayChangeStatus(id) {
    return Client.post(`/${resource}/end-day-status-change`, { id });
  },
  endDayReChangeStatus(id) {
    return Client.post(`/${resource}/re-end-day`, { id });
  },
};
